var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("trigger",null,{"toggle":_vm.toggle,"open":_vm.active}),_c('transition',_vm._g({attrs:{"name":_vm.animation}},_vm.$listeners),[(_vm.active)?_vm._t("default"):_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }